<template>
  <div>
    <Title title="Planifición colaborativa"
           subtitle="Crea us ruta"/>
    <el-row :gutter="20" v-if="planningTracker === null">
      <el-col :lg="7" :md="24">
        <GeneralData ref="generalData"
                     @data="getGeneralData"/>
      </el-col>
      <el-col :lg="17" :md="24">
        <SuborderList @suborders="getSuborders"/>
        <Send ref="sendData"
              @validation="validation"
              @success="successPlanning"/>
      </el-col>
    </el-row>
    <el-row v-else>
      <el-col>
        <PlanningSuccess :planningTracker="planningTracker"/>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import Title from '../components/base/Title.vue';
import Send from '../components/planningCollaborative/Send.vue';
import PlanningSuccess from '../components/planningCollaborative/Success.vue';
import GeneralData from '../components/planningCollaborative/GeneralData.vue';
import SuborderList from '../components/planningCollaborative/suborder/List.vue';

export default {
  name: 'planningCollaborative',
  components: {
    Send,
    Title,
    GeneralData,
    SuborderList,
    PlanningSuccess,
  },
  data() {
    return {
      planningTracker: null,
    };
  },
  methods: {
    validation() {
      this.$refs.generalData.validation();
    },
    getGeneralData(data, validGeneralData) {
      this.$refs.sendData.showSummary(data, validGeneralData);
    },
    getSuborders(data) {
      this.$refs.sendData.getSuborders(data);
    },
    successPlanning(id) {
      this.planningTracker = id;
    },
  },
};
</script>

<style lang="scss" scoped>
  .el-col { margin-bottom: 40px; }
</style>
